const Transport = {
  path: '/transport',
  component: () => import('@/views/pages/transport/TransportRoute.vue'),
  meta: { layout: 'content' },
  children: [
    {
      path: 'handle-solicitation',
      name: 'transport-solicitations',
      component: () => import('@/views/pages/transport/Solicitations/Home.vue'),
      meta: {
        layout: 'content',
      },
    },
    {
      path: 'daily-checklist',
      name: 'transport-daily-checklist',
      component: () => import('@/views/pages/transport/Registrations/DailyCheckList/Home.vue'),
      meta: {
        layout: 'content',
      },
    },
    {
      path: 'driver',
      name: 'register-driver',
      component: () => import('@/views/pages/transport/Registrations/Driver/Home.vue'),
      meta: {
        layout: 'content',
      },
    },
    {
      path: 'vehicle',
      name: 'register-vehicle',
      component: () => import('@/views/pages/transport/Registrations/Vehicle/Home.vue'),
      meta: {
        layout: 'content',
      },
    },

    {
      path: 'battery',
      name: 'register-battery',
      component: () => import('@/views/pages/transport/Registrations/Battery/Home.vue'),
      meta: {
        layout: 'content',
      },
    },
    {
      path: 'maintenance',
      name: 'register-maintenance',
      component: () => import('@/views/pages/transport/Registrations/Maintenance/Home.vue'),
      meta: {
        layout: 'content',
      },
    },
    {
      path: 'mileage',
      name: 'register-mileage',
      component: () => import('@/views/pages/transport/Registrations/Mileage/Home.vue'),
      meta: {
        layout: 'content',
      },
    },
    {
      path: 'fuelSupply',
      name: 'register-fuelSupply',
      component: () => import('@/views/pages/transport/Registrations/FuelSupply/Home.vue'),
      meta: {
        layout: 'content',
      },
    },
    {
      path: 'tools/vehicle',
      name: 'tools-vehicle',
      component: () => import('@/views/pages/transport/Tools/Vehicle/Home.vue'),
      meta: {
        layout: 'content',
      },
    },
    {
      path: 'tools/suppliers',
      name: 'tools-suppliers',
      component: () => import('@/views/pages/transport/Tools/Supplier/Home.vue'),
      meta: {
        layout: 'content',
      },
    },
    {
      path: 'tools/battery',
      name: 'tools-battery',
      component: () => import('@/views/pages/transport/Tools/Battery/Home.vue'),
      meta: {
        layout: 'content',
      },
    },
    {
      path: 'tools/maintenance',
      name: 'tools-maintenance',
      component: () => import('@/views/pages/transport/Tools/Maintenance/Home.vue'),
      meta: {
        layout: 'content',
      },
    },
    {
      path: 'params/permissions',
      name: 'params-permissions',
      component: () => import('@/views/pages/transport/Parameters/Home.vue'),
      meta: {
        layout: 'content',
      },
    },
  ],
}

export default Transport
